import React from 'react';
import styles from './MeterReadDetailsTable.module.css';
import MeterReadDetailsTable from './MeterReadDetailsTable';

/** minimal types so TS is happy */
type Cell = {
  month_year: string;
  value: number | string | null;
  meter_computed_id?: number;
  readonly?: boolean; // Flag for read-only data
};
type Row = { field: string; label: string; months: Cell[]; editable?: boolean };

const MeterReadDetailsMeterSwapTable = ({
  id,
  rows,
  handleChange,
  saving,
  updating,
  start,
  end,
  shouldUseContractView,
  isEditable,
}: {
  id: string | undefined;
  rows: Row[];
  handleChange: any;
  saving: any;
  updating: any;
  start?: Date;
  end?: Date;
  shouldUseContractView?: boolean;
  isEditable?: boolean;
}) => {
  return (
    <MeterReadDetailsTable
      id={id}
      rows={rows}
      handleChange={handleChange}
      saving={saving}
      updating={updating}
      additionalStyles={styles.orphanTable}
      start={start}
      end={end}
      shouldUseContractView={shouldUseContractView}
      isEditable={isEditable ?? true}
      noDecimals
      testTable="meter-swap"
    />
  );
};

export default MeterReadDetailsMeterSwapTable;
